import { sendGTMEvent } from "@next/third-parties/google";
import { GoogleTagManagerEvents } from "../common";
import {
    extractNumber,
    formateAnswer,
} from "../components/Organisms/Survey/constant";

const surveyDropoffCall = async ({
    createUserSurvey,
    surveyAnswers,
    surveyQuestions,
    surveyInfo,
    flag,
}) => {
    try {
        if (!surveyAnswers || !surveyQuestions) {
            console.warn(
                "Survey data not available or invalid. Aborting dropoff call."
            );
            return;
        }
        const formattedPayload = formateAnswer(surveyAnswers);
        const dropOffStep = extractNumber(surveyQuestions?.current);

        const payload = {
            detected_signup_country: flag,
            survey_type_taken: surveyInfo?.surveyType,
            influencer_name: surveyInfo?.influencerName,
            surveypayload: formattedPayload,
            dropoff: dropOffStep,
        };

        sendGTMEvent({
            event: GoogleTagManagerEvents.surveyInteractions,
            interaction_type: "surveyformsteps",
            interaction_item: "SurveyDropOff",
            drop_off: dropOffStep,
        });

        await createUserSurvey(payload);
    } catch (e) {
        console.error("Survey dropoff failed:", e);
    }
};

export default surveyDropoffCall;
